module.exports = __webpack_public_path__ + "img/animation_icon_1.3be25ac6.webp";